export * from './svg-sprite.component';

export enum SvgSpriteIcon {
  Home = '#home',
  HomeFilled = '#home-filled',
  Profile = '#profile',
  ProfileFilled = '#profile-filled',
  Guide = '#guide',
  GuideFilled = '#guide-filled',
  Insights = '#insights',
  InsightsFilled = '#insights-filled',
  Filters = '#filters',
  Brand = '#brand',
  Category = '#category',
  Geography = '#geography',
  GeographyAlt = '#geography-alt',
  Breakdown = '#breakdown',
  BreakdownOff = '#breakdown-off',
  ArrowUp = '#arrow-up',
  ArrowDown = '#arrow-down',
  ArrowNone = '#arrow-none',
  CloseCircle = '#close-circle',
  BeautyAndWellbeing = '#beauty-and-wellbeing',
  PersonalCare = '#personal-care',
  HomeCare = '#home-care',
  Nutrition = '#nutrition',
  IceCream = '#ice-cream',
  TopBottom = '#top-bottom',
  LosingShares = '#losing-shares',
  GrowingShares = '#growing-shares',
  SortingUp = '#sorting-up',
  SortingDown = '#sorting-down',
  ChevronLeft = '#chevron-left',
  ChevronRight = '#chevron-right',
  Close = '#close',
  Close16 = '#close16',
  TODown = '#to-down',
  Filter = '#filter',
  Sort = '#sort',
  SortAlphabetAsc = '#sort-alphabet-asc',
  SortAlphabetDesc = '#sort-alphabet-desc',
  SortAsc = '#sort-asc',
  SortDesc = '#sort-desc',
  ArrowForward = '#arrow-forward',
  ArrowDownSLine = '#arrow-down-s-line',
  ArrowDownRight = '#arrow-down-right',
  ArrowUpLeft = '#arrow-up-left',
  Dashboard = '#dashboard',
  Function = '#function',
  Information = '#information',
  Menu = '#menu',
  Search = '#search',
  Bell = '#bell',
  BellLine = '#bell-line',
  Ai = '#ai',
  ArrowBack = '#arrow-back',
  Eye = '#eye',
  Click = '#click',
  Tap = '#tap',
  LineChart = '#line-chart',
  Cookie = '#cookie',
  TableView = '#table-view',
  BarChart = '#bar-chart',
  ListCheck = '#list-check',
  FunctionLine = '#function-line',
  CloseInsight = '#close-insight',
  ChevronDown = '#chevron-down',
  ArrowRight = '#arrow-right',
  ArrowLeft = '#arrow-left',
}
